import { eMode } from "./../../../content/enum";
import { IDmMucHocPhiTheoMonActionTypes } from "../../action-types/category/IDmMucHocPhiTheoMonActions";
import { IDmMucHocPhiTheoMonReducer } from "../../reducer-model/category/IDmMucHocPhiTheoMonReducer";
import { IDmMucHocPhiTheoMonCopyRequest } from "./../../../model/request/category/dmMucHocPhiTheoMonCopyRequest";
import { eReducerStatusBase } from "./../../reducer-model/eReducerStatusBase";
const iniState: IDmMucHocPhiTheoMonReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mucHocPhiTheoMons: [],
  modeEdit: eMode.xem,
  expandedKeys: [],
  request: {
    hoc_ky: 0,
    ky_dang_ky: 0,
    nam_hoc: "",
    search_key: undefined,
    id_doi_tuong: 0,
    dot_tuyen_sinh: 0,
    hinh_thuc_dao_tao: "chuyen-nganh-chinh",
    id_he: 0,
    khoa_hoc: 0,
    id_chuyen_nganh: 0,
    id_khoi_nganh: 0,
    id_mon: 0,
    id_mons: [],
  },
};
export const mucHocPhiTheoMonReducer = (
  state: IDmMucHocPhiTheoMonReducer = iniState,
  action: IDmMucHocPhiTheoMonActionTypes,
): IDmMucHocPhiTheoMonReducer => {
  switch (action.type) {
    case "MUC_HOC_PHI_THEO_MON_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_HOC_PHI_THEO_MON_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucHocPhiTheoMons: action.payload,
      };
    case "MUC_HOC_PHI_THEO_MON_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_HOC_PHI_THEO_MON_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_HOC_PHI_THEO_MON_SAVE_SUCCESS":
      const updatedIds = action.payload.map((x) => x.id);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucHocPhiTheoMons: [
          ...state.mucHocPhiTheoMons.filter((x) => !updatedIds.includes(x.id)),
          ...action.payload.filter((x) => x.so_tien >= 0),
        ],
      };
    case "MUC_HOC_PHI_THEO_MON_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_HOC_PHI_THEO_MON_UPDATE_STATUS":
      return {
        ...state,
        status: action.payload,
      };
    case "MUC_HOC_PHI_THEO_MON_CHANGE_REQUEST":
      return {
        ...state,
        request: action.payload,
      };
    case "MUC_HOC_PHI_THEO_MON_LOCK_START":
      return {
        ...state,
        request: action.payload,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_HOC_PHI_THEO_MON_LOCK_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucHocPhiTheoMons: action.payload,
      };
    case "MUC_HOC_PHI_THEO_MON_LOCK_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_HOC_PHI_THEO_MON_UNLOCK_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucHocPhiTheoMons: action.payload,
      };
    case "MUC_HOC_PHI_THEO_MON_UNLOCK_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_HOC_PHI_THEO_MON_SHOWHIDE_COPY_MODAL":
      return {
        ...state,
        isShowModalCopy: action.payload,
        requestCopy: {} as IDmMucHocPhiTheoMonCopyRequest,
      };
    case "MUC_HOC_PHI_THEO_MON_COPY_CHANGE_REQUEST":
      return {
        ...state,
        requestCopy: {
          ...state.requestCopy,
          ...action.payload,
        },
      };
    case "MUC_HOC_PHI_THEO_MON_COPY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        mucHocPhiTheoMons: [],
      };
    case "MUC_HOC_PHI_THEO_MON_COPY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucHocPhiTheoMons: action.payload,
        isShowModalCopy: false,
      };
    case "MUC_HOC_PHI_THEO_MON_CHANGE_MODE_EDIT":
      return {
        ...state,
        modeEdit: action.payload,
      };
    case "MUC_HOC_PHI_THEO_MON_CHANGE_EXPANDED_KEYS":
      return {
        ...state,
        expandedKeys: action.payload,
      };
    default:
      return state;
  }
};
